import { render } from "./Sco.vue?vue&type=template&id=84500126&scoped=true"
import script from "./Sco.vue?vue&type=script&lang=js"
export * from "./Sco.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=84500126&scoped=true&lang=css"
import "@/assets/css/user/pages/main.css?vue&type=style&index=1&id=84500126&scoped=true&lang=css"
import "@/assets/css/user/pages/table.css?vue&type=style&index=2&id=84500126&scoped=true&lang=css"
import "@/assets/css/user/pages/sco.css?vue&type=style&index=3&id=84500126&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=4&id=84500126&scoped=true&lang=css"
import "@/assets/css/user/dark/main-dark.css?vue&type=style&index=5&id=84500126&scoped=true&lang=css"
import "@/assets/css/user/dark/sco-dark.css?vue&type=style&index=6&id=84500126&scoped=true&lang=css"
import "./Sco.vue?vue&type=style&index=7&id=84500126&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84500126"]])

export default __exports__